<template>
  <span class="configurator-cup">
    <span
      class="configurator-cup shadowed-cup"
      :class="`shadowed-cup--type-${sizeId}`"
    >
      <img
        :src="src"
        :alt="alt"
        class="configurator-cup__img shadowed-cup__img"
      />
    </span>
  </span>
</template>

<script>
import { DEFAULT_SIZE_ID } from '../../api/static/sizes';

export default {
  name: 'ConfiguratorCup',
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
    sizeId: {
      type: Number,
      default: DEFAULT_SIZE_ID,
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-cup {
  display: block;
}
</style>
